import MUIDrawer from '@mui/material/Drawer';
import React from 'react';
import {styled} from '@mui/material/styles';

import {withDarkTheme} from '../../styles/index.jsx';

export const Drawer = styled(MUIDrawer)(({theme}) => ({
  width: theme.mixins.leftSidebar.width,
  '& .MuiDrawer-paper': {
    position: 'absolute',
    overflow: 'visible',
  },
  '& .MuiDrawer-paperAnchorLeft': {
    width: theme.mixins.leftSidebar.width,
  },
  '& .MuiDrawer-paperAnchorRight': {
    width: theme.mixins.rightSidebar.width,
    backgroundColor: theme.palette.grey[800],
  },
}));

export const LeftDrawer = props => (
  <Drawer anchor="left" variant="persistent" {...props} />
);

export const RightDrawer = withDarkTheme(props => (
  <Drawer anchor="right" variant="persistent" {...props} />
));
